<script lang="ts" setup>
	import {cn} from '@/scripts/utils/utils';
	import {
		DropdownMenuItem,
		type DropdownMenuItemProps,
		useForwardProps,
	} from 'radix-vue';
	import {computed, type HTMLAttributes} from 'vue';

	const props = defineProps<
		DropdownMenuItemProps & {
			class?: HTMLAttributes['class'];
			inset?: boolean;
		}
	>();

	const delegatedProps = computed(() => {
		const {class: _, ...delegated} = props;

		return delegated;
	});

	const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<DropdownMenuItem
		:class="
			cn(
				'focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0',
				inset && 'pl-8',
				props.class
			)
		"
		v-bind="forwardedProps"
	>
		<slot />
	</DropdownMenuItem>
</template>
